/** The calculator is the observed landing surface; other routes keep their existing policy. */
function isPortugueseCalculatorPath(pathname: string): boolean {
	return /^\/pt(?:-br)?\/(?:eu|us)\/peptide-calculator(?:\/[a-z0-9-]+)?\/?$/.test(pathname);
}

export function getBrazilLanguageSignal(
	detectedCountry: string | null,
	preferredBrowserLanguage: string | null,
): "country" | "browser_language" | null {
	if (detectedCountry?.toUpperCase() === "BR") return "country";
	return preferredBrowserLanguage?.toLowerCase() === "pt-br" ? "browser_language" : null;
}

/** A saved Portuguese preference wins over detection, including older cookies without provenance. */
export function shouldSuggestBrazilianPortuguese(input: {
	pathname: string;
	detectedCountry: string | null;
	preferredBrowserLanguage: string | null;
	savedLocale: string | null;
	dismissed: boolean;
}): boolean {
	return (
		input.pathname.startsWith("/pt/") &&
		isPortugueseCalculatorPath(input.pathname) &&
		input.savedLocale !== "pt" &&
		!input.dismissed &&
		getBrazilLanguageSignal(input.detectedCountry, input.preferredBrowserLanguage) !== null
	);
}

/** The language decision must not be followed by an automatic, competing channel modal. */
export function suppressBrazilCalculatorRegionSuggestion(
	pathname: string,
	country: string | null,
	preferredBrowserLanguage: string | null = null,
): boolean {
	return (
		getBrazilLanguageSignal(country, preferredBrowserLanguage) !== null &&
		isPortugueseCalculatorPath(pathname)
	);
}

/** Change only the locale segment; keep the exact query (including duplicates) and fragment. */
export function brazilianCalculatorHref(location: {
	pathname: string;
	search: string;
	hash: string;
}): string | null {
	if (!location.pathname.startsWith("/pt/") || !isPortugueseCalculatorPath(location.pathname)) return null;
	return `${location.pathname.replace(/^\/pt\//, "/pt-br/")}${location.search}${location.hash}`;
}
